import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// 🔐 Firebase yapılandırman
const firebaseConfig = {
  apiKey: "AIzaSyDR2F3PakYJEJo9uqmO9cb367o6X19Epvc",
  authDomain: "aractakip-e606b.firebaseapp.com",
  projectId: "aractakip-e606b",
  storageBucket: "aractakip-e606b.appspot.com",
  messagingSenderId: "327024604844",
  appId: "1:327024604844:web:2cf233c4e8d508bbdf1109"
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
